import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'

import './rem'
import List from "@/views/List";
import Activate from "@/views/Activate";
import Login from "@/views/Login";

Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp']

Vue.use(VueRouter)
Vue.prototype.apiBase = 'https://api.int.youhuohuo.com';
console.log('环境变量', process.env);

const routes = [
  {path: '/', component: List},
  {path: '/login', component: Login},
  {path: '/list', component: List},
  {path: '/activate', component: Activate}
]

// 3. 创建 router 实例，然后传 `routes` 配置
// 你还可以传别的配置参数, 不过先这么简单着吧。
const router = new VueRouter({
  routes // (缩写) 相当于 routes: routes
})

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
